import { useHandler } from '../../useHandlerMutation';

export const useUpdateContact = (contactId: string | undefined) =>
  useHandler((api) => api.contact().updateContact, {
    invalidates: () => [['CONTACTS', contactId]],
  });
